export const GridColumns = [
    {
        Title: 'Correlation Id',
        Accessor: 'correlationId',
        ColumnType: 'Text',
        Sortable: false,
        Id: 'correlationId',
        ClassName: "data-table header"
    },
    {
        Title: 'Message Trigger',
        Accessor: 'eventCode',
        ColumnType: 'Text',
        Sortable: true,
        Id: 'eventCode',
        ClassName: "data-table header"
    },
    {
        Title: 'Unique Id',
        Accessor: 'uniqueId',
        ColumnType: 'Text',
        Sortable: true,
        Id: 'uniqueId',
        ClassName: "data-table header"
    },
    {
        Title: 'Customer',
        Accessor: 'customer',
        ColumnType: 'Text',
        Sortable: true,
        Id: 'customer',
        ClassName: "data-table header"
    },
    {
        Title: 'Message Trigger Data',
        Accessor: 'eventDataPointer',
        ColumnType: 'DownloadableText',
        Sortable: false,
        Id: 'eventDataPointer',
        ClassName: "data-table header"
    },
    {
        Title: 'Receive Time',
        Accessor: 'receiveTime',
        ColumnType: 'Text',
        Sortable: true,
        Id: 'receiveTime',
        ClassName: "data-table header"
    }
];